// extracted by mini-css-extract-plugin
export var active = "Tabs-module--active--5203c";
export var content = "Tabs-module--content--fc104";
export var selector = "Tabs-module--selector--140a5";